import React, { useState, useEffect } from 'react';
import './Contact.css';

const API_URL = process.env.REACT_APP_API_URL;

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', product: '', message: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = 'Contact';
    window.scrollTo(0, 0);
  }, []);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setLoading(true);
    console.log('Submitting form...');
    console.log('Form values:', form);
    console.log('API_URL:', API_URL);
    const payload = JSON.stringify(form);
    console.log('Payload:', payload);
    try {
      const res = await fetch(`${API_URL}/api/send-inquiry`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: payload,
      });
      console.log('Fetch response:', res);
      const data = await res.json().catch(err => {
        console.error('Error parsing JSON:', err);
        return null;
      });
      console.log('Response data:', data);
      if (res.ok && data && data.success) {
        setSuccess(true);
        setSubmitted(true);
        console.log('Form submitted successfully.');
      } else {
        setError(data && data.error ? data.error : 'Submission failed');
        console.error('Submission failed:', data);
      }
    } catch (err) {
      setError('An error occurred.');
      console.error('Error during fetch:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="page-banner" style={{ backgroundImage: 'url(/contact_banner.png)' }}>
        <h1 className="page-banner-title" id="contact-us-heading">
          Contact Us
        </h1>
      </div>
      <section className="contact-form-section-wrapper" aria-labelledby="contact-us-heading">
        <p className="contact-intro-text">
          Get in touch with our team to learn more about how Inalab can help your organization achieve its mission objectives. We're here to answer your questions and explore partnership opportunities. Please fill out the form below and be sure to include all fields.
        </p>
        <div className="contact-form-flex-container">
          <div className="contact-form-inner-container">
            <h2 className="contact-form-heading">General Inquiries</h2>
            <form className="contact-form-styles" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name" className="form-label">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="contact-form-input"
                  value={form.name}
                  onChange={handleChange}
                  required
                  disabled={submitted}
                />
              </div>
              <div className="form-group">
                <label htmlFor="email" className="form-label">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="contact-form-input"
                  value={form.email}
                  onChange={handleChange}
                  required
                  disabled={submitted}
                />
              </div>
              <div className="form-group">
                <label htmlFor="product" className="form-label">Product</label>
                <select
                  id="product"
                  name="product"
                  className="contact-form-select"
                  required
                  disabled={submitted}
                  value={form.product}
                  onChange={handleChange}
                >
                  <option value="">Select Product</option>
                  <option value="iLAB-IS">iLAB-IS</option>
                  <option value="iLAB-FAST">iLAB-FAST</option>
                  <option value="iLAB-SA">iLAB-SA</option>
                  <option value="iLAB-IA">iLAB-IA</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="message" className="form-label">Your Message</label>
                <textarea 
                  id="message"
                  name="message" 
                  placeholder="Your Message" 
                  rows="5" 
                  required 
                  disabled={submitted} 
                  value={form.message} 
                  onChange={handleChange}
                  className="contact-form-textarea"
                ></textarea>
              </div>
              {error && <div className="form-error-message" role="alert">{error}</div>}
              <button
                type="submit"
                className={`submit-button${submitted ? ' submit-button-submitted' : ''}${loading ? ' submit-button-loading' : ''}`}
                disabled={submitted || loading}
              >
                {loading && <span className="spinner" aria-label="Loading"></span>}
                {submitted ? 'Message Sent!' : loading ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </div>
        </div>
      </section>
    </>
  );
} 